// import Dashboard from "../app/Subscription/Dashboard/Dashboard";
// import AuthCheck from "../app/Website/Auth/pages/authCheck";
import { ERolesGuard, EStatus } from "@/Core/enums";
import { dayjsFormat } from "@/Core/Helpers/DayjsHelpers";
import useAuthStore from "@Stores/AuthStore";
import { Badge } from "rizzui";

export function isNullOrUndef(value): boolean {
    return value === undefined || value === null;
}

export function isNullOrUndefOrEmpty(value): boolean {
    return value === undefined || value === null || value === "";
}
export const IsNullOrWhiteSpace = (value) => {
    // Check if value is null or undefined
    if (value === null || value === undefined) return true;

    // Check if value is a string and, if so, trim it and check if it's empty
    if (typeof value === "string" && value.trim() === "") return true;

    return false;
};

// Converter kbps into MB, GB etc...

export const kbpsToHumanReadable = (
    kbps: number,
): {
    KBps: string;
    MB: string;
    GB: string;
    TB: string;
} => {
    const KBps = kbps / 8;
    const MB = KBps / 1024;
    const GB = MB / 1024;
    const TB = GB / 1024;

    return {
        KBps: KBps.toFixed(2) + " KBps",
        MB: MB.toFixed(2) + " MB",
        GB: GB.toFixed(2) + " GB",
        TB: TB.toFixed(2) + " TB",
    };
};

// Check the Permission that You passed If The User Have Or not
export const canAccess = ({
    // role,
    permission,
}: {
    role?: string | string[];
    permission?: string | string[];
}): boolean => {
    const { auth } = useAuthStore.getState();

    // let check: boolean = false;

    // it Developer
    // if (auth.user.isMana) return true;

    if (auth === undefined || auth === null) {
        return false;
    }

    // if both role and permission are empty return true,
    // because it means that the route is public or it allowed to all users
    // if (role == undefined && permission == undefined) {
    if (permission == undefined) {
        return true;
    }

    // only one role
    // if (typeof role === "string" && !IsNullOrWhiteSpace(role)) {
    //     return auth.user?.role?.name == role ? true : false;
    // }
    // only one permission
    // return  (auth.user?.roles?.permissions || []).find((p) => p == permission)
    if (typeof permission === "string" && !IsNullOrWhiteSpace(permission)) {
        return auth.user?.permissions?.includes(permission as string)
            ? true
            : false;
    }

    // list of role
    // if (Array.isArray(role) && !role.isEmpty()) {
    //     return role.includes(auth.user?.role?.name ?? "") ? true : false;
    // }
    // list of permissions
    if (Array.isArray(permission) && !permission.isEmpty()) {
        return (auth.user?.permissions || []).find((p) =>
            permission.includes(p),
        )
            ? true
            : false;
    }
    // role and permissions
    // if (
    //     typeof role === "string" &&
    //     typeof permission === "string" &&
    //     !IsNullOrWhiteSpace(role) &&
    //     !IsNullOrWhiteSpace(permission)
    // ) {
    //     return auth.user?.role?.name == role &&
    //         (auth.user?.role?.permissions || []).find((p) => p === permission)
    //         ? true
    //         : false;
    // }
    // one role and list of permissions
    // if (
    //     typeof role === "string" &&
    //     !IsNullOrWhiteSpace(role) &&
    //     Array.isArray(permission) &&
    //     !permission.isEmpty()
    // ) {
    //     return auth.user?.role?.name == role &&
    //         (auth.user?.role?.permissions || []).find((p) =>
    //             permission.includes(p),
    //         )
    //         ? true
    //         : false;
    // }

    //  list of role and one permission
    // if (
    //     Array.isArray(role) &&
    //     !role.isEmpty() &&
    //     !IsNullOrWhiteSpace(permission)
    // ) {
    //     return role.includes(auth.user?.role?.name ?? "") &&
    //         (auth.user?.role?.permissions || []).find((p) => p == permission)
    //         ? true
    //         : false;
    // }

    // // list of role and list of permission
    // if (
    //     Array.isArray(permission) &&
    //     !permission.isEmpty() &&
    //     Array.isArray(role) &&
    //     !role.isEmpty()
    // ) {
    //     return role.includes(auth.user?.role?.name ?? "") &&
    //         (auth.user?.role?.permissions || []).find((p) =>
    //             permission.includes(p),
    //         )
    //         ? true
    //         : false;
    // }

    return false;
};

type BadgeColors =
    | "primary"
    | "secondary"
    | "danger"
    | "info"
    | "success"
    | "warning";

type BadgeRounded = "none" | "sm" | "md" | "lg" | "pill" | undefined;
type BadgeSizes = "sm" | "md" | "lg" | "xl";

const CustomBadge = ({
    color,
    label,
    rounded = "md",
    size,
}: {
    color: BadgeColors;
    label: string;
    rounded?: BadgeRounded;
    size?: BadgeSizes;
}): JSX.Element => (
    // <Badge
    //     label={IsNullOrWhiteSpace(label) ? "---" : label}
    //     className={`bg-${color}-500 capitalize text-${color}-400 text-white`}
    // />
    <Badge color={color} rounded={rounded} size={size}>
        {label}
    </Badge>
);

export const statusBadge = (status: EStatus): JSX.Element => {
    switch (status) {
        // Very Good
        case EStatus.Active:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Done:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Success:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Completed:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Verified:
            return <CustomBadge label={status} color="success" />;

        // Good
        case EStatus.Received:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Approved:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Accepted:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Owner:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Show:
            return <CustomBadge label={status} color="success" />;
        case EStatus.Scheduled:
            return <CustomBadge label={status} color="success" />;
        case EStatus.InStock:
            return <CustomBadge label={status} color="success" />;

        // Never know
        case EStatus.Dispatch:
            return <CustomBadge label={status} color="info" />;
        case EStatus.OnTheWay:
            return <CustomBadge label={status} color="info" />;
        case EStatus.CheckedIn:
            return <CustomBadge label={status} color="info" />;
        case EStatus.CheckedOut:
            return <CustomBadge label={status} color="info" />;

        // Middle (something in progress or waiting for something)
        case EStatus.NotStarted:
            return <CustomBadge label={status} color="primary" />;
        case EStatus.OnHold:
            return <CustomBadge label={status} color="info" />;
        case EStatus.InQueue:
            return <CustomBadge label={status} color="info" />;
        case EStatus.Delivered:
            return <CustomBadge label={status} color="info" />;
        case EStatus.Pending:
            return <CustomBadge label={status} color="info" />;
        case EStatus.Waiting:
            return <CustomBadge label={status} color="info" />;
        case EStatus.Processing:
            return <CustomBadge label={status} color="info" />;
        case EStatus.InProgress:
            return <CustomBadge label={status} color="info" />;
        case EStatus.Request:
            return <CustomBadge label={status} color="info" />;

        // Bad
        case EStatus.Failed:
            return <CustomBadge label={status} color="warning" />;
        case EStatus.NotOwner:
            return <CustomBadge label={status} color="warning" />;
        case EStatus.Disabled:
            return <CustomBadge label={status} color="warning" />;
        case EStatus.Warning:
            return <CustomBadge label={status} color="warning" />;
        case EStatus.Hidden:
            return <CustomBadge label={status} color="warning" />;
        case EStatus.ReSchedule:
            return <CustomBadge label={status} color="warning" />;
        case EStatus.OutOfStock:
            return <CustomBadge label={status} color="warning" />;

        // Worst
        case EStatus.Suspended:
            return <CustomBadge label={status} color="danger" />;
        case EStatus.Blocked:
            return <CustomBadge label={status} color="danger" />;
        case EStatus.Declined:
            return <CustomBadge label={status} color="danger" />;
        case EStatus.Cancel:
            return <CustomBadge label={status} color="danger" />;
        case EStatus.Reject:
            return <CustomBadge label={status} color="danger" />;

        default:
            return (
                <CustomBadge
                    label={status}
                    color="info"
                    // className="bg-white capitalize text-slate-500 bg-opacity-[0.11] "
                />
            );
    }
};

export const RoleBadge = (status: ERolesGuard): JSX.Element => {
    switch (status) {
        case ERolesGuard.Users_Role:
            return (
                <CustomBadge
                    label={"User Role"}
                    color="success"
                    // className="bg-success-500 capitalize text-success-500 bg-opacity-[0.11] "
                />
            );
        case ERolesGuard.System_Role:
            return (
                <CustomBadge
                    label={"System Role"}
                    color="info"
                    // className="bg-teal-500 capitalize text-teal-500 bg-opacity-[0.11] "
                />
            );
    }
};

export const formatData = (value) => {
    if (typeof value === "string") {
        // Capitalize the first letter of the string
        return value.charAt(0).toUpperCase() + value.slice(1);
    } else if (typeof value === "number") {
        // Format the number with commas
        return value.format();
    } else if (typeof value === "boolean") {
        // Return "Yes" for true and "No" for false
        return value ? "Yes" : "No";
    } else if (value instanceof Date) {
        // Format the date as "MM/DD/YYYY"
        return dayjsFormat(value);
    }

    // Return the value as is for other types
    return value;
};
